$(function() {

    $.imax = {};

    $.imax.delayFadeOut = ($("#imax-container").next('section').hasClass('profile-section')) ? false : true;

    $.imax.lastProfile = false;

    // durations

    $.imax.duration = '75%';

    $.imax.calculatePinDuration = function() {
        var contentHeight = $('#imax-container .content-container').outerHeight();
        if ($.imax.lastProfile) {
            $.imax.pinDuration = 0;
        } else {
            $.imax.pinDuration = Math.round(contentHeight + $(window).innerHeight());
        }
        return $.imax.pinDuration;
	};

    $.imax.zoomDuration = '100%';

    $.imax.endDuration = ($.imax.delayFadeOut) ? '150%' : '50%';

    // timelines

    $.imax.tl = {};

    // in

	$.imax.tl.in = new TimelineMax();

    $.imax.tl.in.addLabel("start");

    $.imax.tl.in.set("#imax-container", { visibility: "visible" }, "start");﻿

    if (!$.ms) {

        $.imax.tl.in.from("#imax-svg .line-1", 1, { x:"2560" }, "start");
        $.imax.tl.in.from("#imax-svg .line-2", 1, { x:"2560", delay: 0.25 }, "start");
        $.imax.tl.in.from("#imax-svg .line-3", 1, { x:"2560", delay: 0.5 }, "start");
        $.imax.tl.in.add(function(){ /* pause */ }, "+=0.25");

        new ScrollMagic.Scene({ triggerElement: '#imax-in', triggerHook: 'onEnter', duration: $.imax.duration })
        	.setTween($.imax.tl.in)
        	// .addIndicators({name: 'imax in'})
        	.addTo($.controller);

    }

    // pin

    new ScrollMagic.Scene({ triggerElement: '#imax-pin', triggerHook: 'onLeave', duration: $.imax.calculatePinDuration })
        .setPin('#imax-container .svg-background')
        // .addIndicators({name: 'imax pin'})
        .addTo($.controller);

    // zoom

    $.imax.zoom = {};

    $.imax.tl.zoom = new TimelineMax();

    $.imax.tl.zoom.addLabel("start");
    $.imax.tl.zoom.addLabel("content", 2);

    if ($.ms || ($.windowWidth > $.breakpoint.e3 && $.safari)) { // zoom

        $.imax.tl.zoom.to("#imax-svg .svg-text", 2, { y:"-320" }, "start");

    } else {

        $.imax.zoom.scale = 10;
        $.imax.zoom.offset = $.imax.zoom.scale * 100 / 2;
        $.imax.zoom.xy = "-"+ $.imax.zoom.offset +"%";

        $.imax.tl.zoom.to("#imax-svg .svg-text", 2, { x:$.imax.zoom.xy, y:$.imax.zoom.xy, scaleX:$.imax.zoom.scale, scaleY:$.imax.zoom.scale, force3D:true }, "start");

    }

    $.imax.tl.zoom.to("#imax-container .svg-img-overlay-mask", 0.5, { opacity:0 }, "start");
    $.imax.tl.zoom.to("#imax-background", 0.5, { backgroundColor:$.color.black, delay:1 }, "start");
    $.imax.tl.zoom.fromTo("#imax-svg .svg-img .img-default", 0.5, { opacity:0 }, { opacity:1, delay:1.5 }, "start");
    $.imax.tl.zoom.set("#imax-svg .svg-bg", { visibility:"hidden", delay:2 }, "start");﻿
    $.imax.tl.zoom.set("#imax-svg .svg-img-mask", { visibility:"hidden", delay:2 }, "start");﻿

    $.imax.tl.zoom.fromTo("#imax-container .svg-img-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    $.imax.tl.zoom.fromTo("#imax-container .svg-content-overlay", 0.5, { opacity:0 }, { opacity:1 }, "content");
    if ($.windowWidth > $.breakpoint.lg) {
        $.imax.tl.zoom.fromTo("#imax-container .svg-content-overlay", 0.5, { x:"-100%" }, { x:"0%" }, "content");
    }
    $.imax.tl.zoom.fromTo("#imax-container .content-container", 0.5, { opacity:0 }, { opacity:1, delay:0.5 }, "content");

    new ScrollMagic.Scene({ triggerElement: '#imax-zoom', triggerHook: 'onCenter', duration: $.imax.zoomDuration })
        .on('start', function () {
            $.imax.tl.in.seek($.imax.tl.in.duration(), false);
        })
        .setTween($.imax.tl.zoom)
        // .addIndicators({name: 'imax zoom'})
        .addTo($.controller);

    $.imax.tl.out = new TimelineMax();

    $.imax.tl.out.addLabel("start");

    $.imax.tl.out.to("#imax-container .content-container", 1, { opacity:0 }, "start");

    if ($.imax.delayFadeOut) {
        $.imax.tl.out.to("#imax-background", 1, { opacity:0, delay:2 }, "start");
    } else {
        $.imax.tl.out.to("#imax-background", 1, { opacity:0 }, "start");
    }

    new ScrollMagic.Scene({ triggerElement: '#imax-end', triggerHook: 'onCenter', duration: $.imax.endDuration })
        .setTween($.imax.tl.out)
        // .addIndicators({name: 'imax out'})
        .addTo($.controller);

});
